import { Toaster } from "sonner";

export function NotificationsToaster() {
    return <Toaster position="bottom-right" />;
}
